import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, setAuthToken } from '@/lib/api';
import { toast } from 'sonner';

function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('Authentication failed');
        navigate('/');
        return;
      }

      try {
        const response = await API.post('/auth/session', { session_id: sessionId });
        const { user, session_token } = response.data;
        
        setAuthToken(session_token);
        document.cookie = `session_token=${session_token}; path=/; max-age=${7*24*60*60}; secure; samesite=none`;
        
        window.history.replaceState({}, document.title, '/onboarding');
        navigate('/onboarding', { state: { user }, replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Authentication failed');
        navigate('/');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-green-500 mx-auto mb-4"></div>
        <p className="text-white text-lg">Authenticating...</p>
      </div>
    </div>
  );
}

export default AuthCallback;